import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Box,Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
const ServerErrorModal = ({serverError,isLLP,  toggleModalFn,handleTabChange}) => {
    return(
        <>
            <Dialog
                open={serverError.modal}
                onClose={toggleModalFn}
                className='server-error-modal'
                maxWidth="md"
            >
                <DialogTitle id="scroll-dialog-title">
                    Verify Amount Error
                </DialogTitle>
                <DialogContent className="error-dialog-content" dividers={true}>
                        {serverError?.data?.map((err,idx)=>{
                            return( <Box key={idx} display="flex" alignItems="start" mb={1}>
                                <ErrorIcon fontSize="small" color="error" style={{  marginRight: 8 }} />
                                <Typography variant="body2">{err.key}: {err.message}   </Typography>
                              </Box>)
                        })}        
                </DialogContent>
                <DialogActions>
                    <Button className='cancel-btn' onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ServerErrorModal;